<template>
  <div>
    <div class="p-6 pb-0">
      <BreadCrumbs :navigation="navigation" />
    </div>
    <div class="p-6 pb-0">
      <!-- Selettore sessione inventario -->
      <div class="mb-6">
        <label class="block text-sm font-medium mb-2">{{ $t('gm.select_inventory_session') }}</label>
        <div class="flex space-x-2">
          <select v-model="selectedSession" :disabled="!!selectedSession" class="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500">
            <option disabled value="">-- {{ $t('gm.choose_session') }} --</option>
            <option v-for="session in sessions" :key="session.id" :value="session.id">
              {{ $t('gm.created_by') }} {{ session.name }} {{ $t('gm.deposit') }}: {{ session.extra.storage }} il {{ new Date(session.created_at).toLocaleDateString() }}
            </option>
          </select>
          <button class="bg-green-500 text-white px-4 py-2 rounded" @click="showNewSessionModal = true" :disabled="!!selectedSession">{{ $t('gm.create_new_inventory_session') }}</button>
          <button
            v-if="selectedSession"
            class="bg-red-500 text-white px-4 py-2 rounded"
            @click="showDeleteSessionModal = true"
          >
            {{ $t('gm.delete_session') }}
          </button>
        </div>
      </div>
      <!-- Modal nuova sessione -->
      <ConfirmationModal :show="showNewSessionModal" @close="showNewSessionModal = false">
        <template #title>
          {{ $t('gm.create_new_inventory_session') }}
        </template>
        <template #content>
          <select
            v-model="sessionWarehouse"
            class="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            style="background-color: #fff;"
            @change="$refs.barcodeInput.focus()"
            :disabled="!!selectedSession"
          >
            <option disabled value="">-- {{ $t('gm.choose_a_warehouse') }} --</option>
            <option v-for="storage in storages" :key="storage.Storage" :value="storage.Storage">{{ storage.Storage }} ( {{ storage.Description }} )</option>
          </select>
        </template>
        <template #footer>
          <SecondaryButton @click="showNewSessionModal = false">{{ $t('actions.cancel') }}</SecondaryButton>
          <PrimaryButton class="ms-3" @click="createSession" :disabled="!!selectedSession">{{ $t('actions.create') }}</PrimaryButton>
        </template>
      </ConfirmationModal>
      <!-- Modal conferma elimina sessione -->
      <ConfirmationModal :show="showDeleteSessionModal" @close="showDeleteSessionModal = false">
        <template #title>
          {{ $t('gm.confirm_session_deletion') }}
        </template>
        <template #content>
          {{ $t('gm.confirm_session_deletion_confirm') }}
        </template>
        <template #footer>
          <SecondaryButton @click="showDeleteSessionModal = false">{{ $t('actions.cancel') }}</SecondaryButton>
          <PrimaryButton class="ms-3" @click="deleteSession">{{ $t('actions.delete') }}</PrimaryButton>
        </template>
      </ConfirmationModal>
      <!-- Selettore Magazzino e resto solo se sessione selezionata -->
      <div v-if="selectedSession">
        <div class="mb-6">
          <label class="block text-sm font-medium mb-2">{{ $t('gm.choose_a_warehouse') }}</label>
          <select
            v-model="selectedWarehouse"
            :disabled="!!selectedWarehouse"
            class="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            style="background-color: #fff;"
            @change="$refs.barcodeInput.focus()"
          >
            <option disabled value="">-- {{ $t('gm.choose_a_warehouse') }} --</option>
            <option v-for="storage in storages" :key="storage.Storage" :value="storage.Storage">{{ storage.Storage }} ( {{ storage.Description }} )</option>
          </select>
        </div>
        <!-- Pulsante conferma inventario -->
        <div class="mb-4">
          <button
            class="bg-blue-600 text-white px-4 py-2 rounded"
            @click="showConfirmInventoryModal = true"
            :disabled="!selectedSession"
          >
            {{ $t('actions.confirm') }}
          </button>
        </div>
        <!-- Mostra il resto solo se selezionato -->
        <div v-if="selectedWarehouse">
          <div class="flex items-center justify-between mb-4">
          <label class="block text-sm font-medium mb-2">{{ $t('core.article_list') }}</label>
            <button class="text-white bg-gray-500 font-medium rounded-lg text-sm px-4 py-2.5 text-center" @click="showFilters = true">
              {{ $t('actions.filters') }}
            </button>
          </div>
          <!-- Input barcode -->
          <div class="mb-6">
            <div class="relative">
              <input
                ref="barcodeInput"
                v-model="barcodeSearch"
                type="text"
                placeholder="Cerca per codice a barre articolo..."
                class="w-full p-3 pr-10 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                @keyup.enter="searchItemfromBarcode"
                autofocus
              >
              <div class="absolute right-3 top-3 text-gray-400">
                <i class="fa fa-search"></i>
              </div>
            </div>
          </div>
          <!-- Modal Filtri -->
          <div v-if="showFilters" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
            <div class="bg-white rounded-lg shadow-lg w-11/12 max-w-md p-6 relative">
              <button class="absolute top-2 right-2 text-gray-400 hover:text-gray-600" @click="showFilters = false">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
              <h3 class="text-lg font-semibold mb-4">{{ $t('actions.filters') }}</h3>
              <div class="mb-4 space-y-4">
                <div v-for="header in headers.filter(x => x.value !== 'select')" class="mb-4">
                  <label class="block text-sm font-medium mb-1">{{ header.title || header.value }}</label>
                  <input
                    v-model="header.filtervalue"
                    type="text"
                    class="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    :placeholder="$t('gm.filter_by') + ' ' + (header.title || header.value)"
                  >
                </div>
              </div>
              <div class="flex justify-end space-x-2">
                <button class="bg-gray-300 text-gray-700 px-4 py-2 rounded" @click="showFilters = false">{{ $t('actions.cancel') }}</button>
                <button class="bg-blue-500 text-white px-4 py-2 rounded" @click="applyFilters">{{ $t('actions.apply') }}</button>
              </div>
            </div>
          </div>
          <!-- Fine Modal Filtri -->

          <div v-if="filtersApplied">
            <PageServerTable
              :headers="headersFiltered"
              :items="items"
              :items-per-page.sync="ipp"
              :items-per-page-options="ippo"
              :sort-by="sortby"
              :items-length="count"
              :reload-fn="reload"
              :item-value="'Item'"
              :page="page"
              show-current-page
            >
              <template #item.select="{ item }">
                <div class="flex items-center space-x-2">
                  <button class="text-white bg-blue-400 dark:bg-blue-500 font-medium rounded-lg text-sm px-3 py-1.5 text-center" @click="addItem(item.Item)">+</button>
                  <button class="text-blue-500 border border-blue-400 rounded-lg px-2 py-1 text-sm" @click="showItemInfo(item)">
                    <i class="fa fa-info-circle"></i>
                  </button>
                </div>
              </template>
            </PageServerTable>
          </div>
          <br>
        </div>
      </div>
      <!-- Modal conferma inventario -->
      <ConfirmationModal :show="showConfirmInventoryModal" @close="showConfirmInventoryModal = false">
        <template #title>
          {{ $t('gm.confirm_inventory') }}
        </template>
        <template #content>
          {{ $t('gm.confirm_inventory_confirmation') }}
        </template>
        <template #footer>
          <SecondaryButton @click="showConfirmInventoryModal = false">{{ $t('actions.cancel') }}</SecondaryButton>
          <PrimaryButton class="ms-3" @click="sendInventory">{{ $t('actions.confirm') }}</PrimaryButton>
        </template>
      </ConfirmationModal>
    </div>

    <ConfirmationModal :show="showBarCodeModal" @close="showBarCodeModal = false">
      <template #title>
        {{ $t('gm.insert_qty') }}
      </template>
      <template #content>
        {{ $t('gm.insert_qty_for', { item: barcodeItem }) }}<br>
        <input
          ref="barcodeQtyInput"
          v-model.number="barcodeQty"
          onfocus="this.select()"
          type="number"
          min="0"
          class="w-full p-3 pr-10 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
        <div v-if="barcodeItem">Già registrato in questo inventario da questo utente: {{ alreadyPresent }}</div>
      </template>
      <template #footer>
        <SecondaryButton @click="showBarCodeModal = false">
          {{ $t('actions.cancel') }}
        </SecondaryButton>
        <PrimaryButton class="ms-3" @click="setBarcodeQty">
          {{ $t('actions.set') }}
        </PrimaryButton>
      </template>
    </ConfirmationModal>

    <ConfirmationModal :show="showInfoModal" @close="showInfoModal = false">
      <template #title>
        {{ $t('gm.article_details') }}
      </template>
      <template #content>
        <div v-if="infoItem">
          <div><b>{{ $t('gm.code') }}:</b> {{ infoItem.Item }}</div>
          <div><b>{{ $t('gm.description') }}:</b> {{ infoItem.Description }}</div>
          <div><b>{{ $t('gm.product_category') }}:</b> {{ infoItem.CommodityCtg }}</div>
          <div><b>{{ $t('gm.homogeneous_category') }}:</b> {{ infoItem.HomogeneousCtg }}</div>
        </div>
      </template>
      <template #footer>
        <PrimaryButton class="ms-3" @click="showInfoModal = false">
          {{ $t('actions.close') }}
        </PrimaryButton>
      </template>
    </ConfirmationModal>
  </div>
</template>

<script>
import { Link, router, useForm } from '@inertiajs/vue3';
import BreadCrumbs from '@/Components/BreadCrumbs.vue';
import Pagination from '@/Components/Pagination.vue';
import PageServerTable from '@/Components/PageServerTable.vue';
import PageNormalTable from '@/Components/PageNormalTable.vue';
import axios from 'axios';
import ConfirmationModal from '@/Components/ConfirmationModal.vue';
import PrimaryButton from '@/Components/PrimaryButton.vue';
import SecondaryButton from '@/Components/SecondaryButton.vue';

export default {
  props: ['items', 'count', 'ippo', 'headersInventory', 'storages', 'sessions'],
  components: {
    Link,
    BreadCrumbs,
    Pagination,
    PageServerTable,
    PageNormalTable,
    ConfirmationModal,
    PrimaryButton,
    SecondaryButton
  },
  data() {
    return {
      search: this.filters?.search || "",
      navigation: [
        { name: 'Dashboard', href: route('dashboard') },
        { name: this.$t('modules.gestione-magazzino'), href: route('modules.home', 'gestione-magazzino') },
        { name: this.$t('modules.inventario'), href: route('modules.gm.inventario') }
      ],
      inventoryrows: [],
      headers: [],
      sortby: [],
      ipp: 10,
      page: 1,
      showFilters: false,
      selectedWarehouse: "",
      barcodeSearch: '',
      showBarCodeModal: false,
      barcodeItem: null,
      barcodeQty: 0,
      showInfoModal: false,
      infoItem: null,
      filtersApplied: false,
      selectedSession: "",
      showNewSessionModal: false,
      sessionWarehouse: "",
      alreadyPresent: 0,
      showDeleteSessionModal: false,
      showConfirmInventoryModal: false,
    };
  },
  computed: {
    headersFiltered() {
      // Mostra solo Item e selettore
      return this.headers.filter(h => h.value === 'Item' || h.value === 'select');
    }
  },
  methods: {
    reload(sortby = undefined, itemsperpage = undefined, page = undefined, afterdeletion = false) {
      /*if (afterdeletion)
      return;*/

        if (sortby) this.sortby = sortby;
        if (itemsperpage) this.ipp = itemsperpage;
        if (page) this.page = page;

        //sortBy e ipp passano solo il valore aggiornato come $event, non si modifica realmente, quindi ricaricare le prop
        router.post(window.location.href, { 
            headers: this.headers, 
            sortby: this.sortby, 
            itemsperpage: this.ipp, 
            page: this.page, 
            search: this.search,
            storage: this.selectedWarehouse
        }, { only: ['items', 'count'], onSuccess: (page) => {
            this.filtersApplied = true;
        },})
    },
    addItem(item){
      let _this = this;
      axios.post(route('modules.gm.controllaarticolo'), { item: item, session: this.selectedSession }, {
        headers: {
          'X-No-Trim': true
        }
    }).
      then((response) => {
        if (response.data.success)
        {
            _this.barcodeItem = item;
            _this.barcodeQty = 1;
            _this.alreadyPresent = response.data.BookInv;
            _this.showBarCodeModal = true;
            _this.barcodeSearch = '';
        }
        else {
            alert('Errore.');
        }
      });
    },
    sendInventory() {
      axios.post(route('modules.gm.salvaInventario'), { session: this.selectedSession })
        .then(response => {
          if (response.data.success) {
            alert("Inventario confermato.");
            window.location.reload();
          } else {
            alert("Errore durante la conferma dell'inventario.");
          }
        });
    },
    createSession() {
      // Esegui chiamata per creare una nuova sessione, poi aggiorna la lista e seleziona la nuova
      axios.post(route('modules.gm.creasessione'), { storage: this.sessionWarehouse })
        .then(response => {
          if (response.data.success) {
            this.sessions.push(response.data.data);
            this.selectedSession = response.data.data.id;
            this.selectedWarehouse = this.sessionWarehouse;
            this.showNewSessionModal = false;
          } 
          else if (response.data.success === false && response.data.message) {
            alert(response.data.message);
          }
          else {
            alert('Errore nella creazione della sessione');
          }
        });
    },
    deleteSession() {
      if (!this.selectedSession) return;
      axios.post(route('modules.gm.eliminasessione'), { session: this.selectedSession })
        .then(response => {
          if (response.data.success) {
            window.location.reload();
          } else {
            alert('Errore durante l\'eliminazione della sessione');
          }
        });
    },
    applyFilters() {
      this.showFilters = false;
      this.reload();
    },
    searchItemfromBarcode() {
      let _this = this;
      axios.post(route('modules.gm.cercabarcode'), { barcode: this.barcodeSearch })
        .then((response) => {
          if (response.data && response.data.length > 0) {
            _this.addItem(response.data[0].Item);
            // Attendi che addItem aggiorni inventoryrows, poi mostra popup quantità
          } else {
            alert('Articolo non trovato.');
          }
        });
    },
    setBarcodeQty() {
      let _this = this;
      axios.post(route('modules.gm.invaggiungisession'), { item: this.barcodeItem, session: this.selectedSession, qty: this.barcodeQty }, {
        headers: {
          'X-No-Trim': true
        }
      }).
      then((response) => {
        if (response.data.success)
        {
          _this.showBarCodeModal = false;
        }
        else {
            alert('Errore.');
        }
      });

    },
    showItemInfo(item) {
      this.infoItem = item;
      this.showInfoModal = true;
    },
  },
  watch: {
    selectedSession(newVal) {
      if (newVal) {
        const session = this.sessions.find(s => s.id === newVal);
        if (session && session.extra && session.extra.storage) {
          this.selectedWarehouse = session.extra.storage;
        }
      }
    },
    showBarCodeModal(val) {
      if (val) {
        this.$nextTick(() => {
          if (this.$refs.barcodeQtyInput) {
            this.$refs.barcodeQtyInput.focus();
          }
        });
      } else {
        // Quando il modal viene chiuso, rimetti il focus sull'input barcode se presente
        this.$nextTick(() => {
          if (this.$refs.barcodeInput) {
            this.$refs.barcodeInput.focus();
          }
        });
      }
    }
  },
  watch: {
    selectedSession(newVal) {
      if (newVal) {
        const session = this.sessions.find(s => s.id === newVal);
        if (session && session.extra && session.extra.storage) {
          this.selectedWarehouse = session.extra.storage;
          this.filtersApplied = false;
        }
      } else {
        this.selectedWarehouse = "";
        this.filtersApplied = false;
      }
    }
  },
  mounted()
  {
    //Primo caricamento
    this.headers = this.$attrs.headers;
    this.ipp = this.$attrs.ipp;
    this.page = this.$attrs.page;
    this.sortby = this.$attrs.sortby;
  }
};
</script>